<template>
  <div class="flex h-full min-h-0 flex-col gap-3">
    <div class="flex shrink-0 flex-wrap items-center gap-x-5 gap-y-2">
      <div class="flex flex-row gap-1">
        <BaseButton
          color="secondary"
          icon="chevron-left"
          :tooltip="$t('global.previous_week')"
          @click="getPreviousWeekTimeslots"
        />
        <BaseButton
          color="secondary"
          icon="chevron-right"
          :tooltip="$t('global.next_week')"
          @click="getNextWeekTimeslots"
        />
        <BaseButton
          class="ml-2"
          color="secondary"
          :title="$t('global.today')"
          @click="getCurrentWeekTimeslots"
        />
      </div>
      <p class="text-xl leading-none font-medium capitalize-first">
        {{ cDateRange }}
      </p>
    </div>
    <div
      v-if="no_timeslot"
      class="shrink-0 leading-none font-medium text-theme-21"
    >
      {{
        $t('validation.there_is_no_for_f', {
          settings: $t('attributes.timeslot'),
          container: $t('global.week')
        })
      }}
    </div>

    <RadioGroup
      class="min-h-0 flex-1 overflow-y-auto p-1"
      :model-value="modelValue"
      @update:model-value="$emit('update:modelValue', $event)"
    >
      <div class="grid grid-cols-3 gap-2">
        <template v-for="(disp, index) in options">
          <RadioGroupOption
            as="template"
            :value="disp"
            v-slot="{ active, checked }"
          >
            <div
              :class="[
                active
                  ? 'ring-2 ring-white/60 ring-offset-2 ring-offset-primary-300'
                  : '',
                checked
                  ? 'bg-primary-500 text-white'
                  : 'bg-gray-200 hover:bg-gray-300'
              ]"
              class="relative col-span-1 flex cursor-pointer rounded-md px-3 py-2 shadow-sm focus:outline-hidden"
            >
              <div class="flex w-full items-center">
                <RadioGroupLabel
                  as="div"
                  :class="checked ? 'text-white' : 'text-gray-900'"
                  class="flex flex-1 font-medium"
                >
                  <div class="flex-1 capitalize-first select-none">
                    {{ formatTitle(disp.date) }}
                  </div>
                  <div class="flex-shrink-0 select-none">
                    {{ disp.string_from }}
                  </div>
                </RadioGroupLabel>
              </div>
            </div>
          </RadioGroupOption>
        </template>
      </div>
    </RadioGroup>
  </div>
</template>

<script>
import {
  RadioGroup,
  RadioGroupLabel,
  RadioGroupDescription,
  RadioGroupOption
} from '@headlessui/vue'
import moment from 'moment'
import { mapActions } from 'vuex'

export default {
  name: 'SelectEventTimeslot',
  emits: ['update:modelValue'],
  props: [
    'modelValue',
    'selectedType',
    'type',
    'asset',
    'eventKind',
    'options',
    'index'
  ],
  data() {
    return {
      no_timeslot: false,

      currentWeekNumber: null,
      weekDelta: 0
    }
  },
  components: {
    RadioGroup,
    RadioGroupLabel,
    RadioGroupDescription,
    RadioGroupOption
  },
  computed: {
    cDateRange() {
      if (this.options && this.options.length === 0) {
        this.no_timeslot = true
        return ''
      } else {
        this.no_timeslot = false
      }
      return this.options && this.options.length
        ? `${moment(this.options[0].date).locale('fr').format('dddd D')} -
        ${moment(this.options[this.options.length - 1].date)
          .locale('fr')
          .format('dddd D MMMM YYYY')}`
        : ''
    }
  },
  methods: {
    ...mapActions({
      fetchEventDisponbilitiesByOption: 'fetchEventDisponbilitiesByOption'
    }),
    formatTitle(date) {
      return moment(date).locale('fr').format('dddd D MMM')
    },
    fetchTimeslotsByDate(date) {
      this.fetchEventDisponbilitiesByOption({
        params: {
          asset_id: this.asset,
          type: this.type,
          week_from: date,
          year: moment().format('YYYY'),
          event_kind_id: this.eventKind
        },
        index: this.index
      })
    },
    getPreviousWeekTimeslots() {
      if (this.weekDelta > 0) this.weekDelta--
      if (!this.currentWeekNumber) {
        this.currentWeekNumber = moment().locale('fr').week()
      }
      if (this.weekDelta >= 0) {
        this.fetchTimeslotsByDate(this.currentWeekNumber + this.weekDelta)
      }
    },
    getNextWeekTimeslots() {
      this.weekDelta++

      if (!this.currentWeekNumber) {
        this.currentWeekNumber = moment().locale('fr').week()
      }
      if (this.weekDelta > 0) {
        this.fetchTimeslotsByDate(this.currentWeekNumber + this.weekDelta)
      }
    },
    getCurrentWeekTimeslots() {
      this.weekDelta = 0

      if (!this.currentWeekNumber) {
        this.currentWeekNumber = moment().locale('fr').week()
      }
      this.fetchTimeslotsByDate(this.currentWeekNumber)
    }
  },
  watch: {
    isOpen(newValue) {
      this.getCurrentWeekTimeslots()
    }
  }
}
</script>

<style scoped></style>
